import responseErrorGenerator from 'global/lib/api/responseError'

export default responseErrorGenerator('')
